export enum DIALOG_IDS {
  LOGIN = 'login',
  RESET_PASSWORD = 'reset-password'
}
